<template>
	<div id="voucher_word"  class="public-content">
		<!-- 公共form表单样式 -->
		<div class="form-item-public" style="width:500px" v-loading='isLoading'>
			<el-form label-width="165px" label-position="right" :model="formData">
				<el-form-item label="主管名称：" >
					<el-input v-model="formData.executive" size="small" placeholder="请输入主管名称"></el-input>
				</el-form-item>

				<el-form-item label="审核员姓名：" >
					<el-input v-model="formData.auditor" size="small" placeholder="请输入审核员姓名"></el-input>
				</el-form-item>

				<el-form-item label="出纳：" >
					<el-input v-model="formData.cashier" size="small" placeholder="请输入出纳"></el-input>
				</el-form-item>

				<el-form-item label="制单人：" >
					<el-input v-model="formData.single" size="small" placeholder="请输入制单人"></el-input>
				</el-form-item><br>
        <el-form-item label="封面公司设置：" >
					<el-radio-group v-model="formData.fillType">
            <el-radio v-for="(item, index) in chooseData" :key="index" :label = "item.value">{{ item.name }}</el-radio>
          </el-radio-group>
          <el-input v-model="formData.fillContent" size="small" placeholder="请输入自定义名称" v-if="formData.fillType == 3" ></el-input>
				</el-form-item><br>
				<el-form-item label="">
					<el-button size="small" class='minButton' @click="savePrintSet">保存</el-button>
				</el-form-item>
			</el-form>
		</div>


	</div>
</template>

<script>
import publicTable from '@/components/publicTable'
export default {
	components:{
		publicTable
	},
	data(){
		return {
			isLoading: false,
			title:'打印设置',
      chooseData: [
        { name: "自动填充", value: 1 },
        { name: "不填充", value: 2 },
        { name: "自定义输入", value: 3 },
      ],
			formData:{
        fillType: 1,
        fillContent: "",
				single:'',
				cashier:'',
				auditor:'',
				executive:''
			},
			// printSetRule:{
			// 	cashier:[:true,message:'出纳必填!'}],
			// 	auditor:[{required:true,message:'审核员姓名必填!'}],
			// 	executive:[{required:true,message:'主管名称必填!'}]
			// }
		}
	},
	created(){
		this.getPrintSet();
	},
	methods:{
		// 保存打印
		savePrintSet(){

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			try {
				this.isLoading = true;
				this.$http.post('advancedSetting/save' , this.formData).then(res=>{
					this.isLoading = false;
					if(res) {
						this.getPrintSet();
						this.$message.success('保存成功！')
					}
				})
			}catch(e) {
				this.isLoading = false;
			}

		},
		// 获取打印
		getPrintSet() {
			try {
				this.isLoading = true;
				this.$http.post('advancedSetting/getAdvanced',{}).then(res=>{

					this.isLoading = false;
					if(res) {
						this.formData = Object.assign({} , {
							single:res.data.data.single,
							cashier:res.data.data.cashier,
							auditor:res.data.data.auditor,
							fillType:res.data.data.fillType,
							fillContent:res.data.data.fillContent,
							executive:res.data.data.executive
						})
					}
				})
			}catch(e) {
				this.isLoading = false;
			}
		},

	},
	mounted() {

	},
}
</script>

<style lang="less" scoped>
	#voucher_word{

	}
</style>



// WEBPACK FOOTER //
// src/pages/setting/printSettings.vue